// Test_ Blue Print.xlsx exported as a CSV
const csv = `Entries,Categories ,Education,Subjects covered,Ques,Marks,Time(Mins),Marking System,Marking
Officer Entry,"NDA/ ACC
","12th in Arts, Commerce, Science",PAPER 1(MCQ),120,300,150 Mins,For every right answer,2.5 Marks
,,,Maths,120,300,,Negative Marks for every wrong answer,1/3 Marks
,,,PAPER 2(MCQ),150,600,150 Mins,For every right answer,4 Marks
,,,Section - A(Gen Ability),,,,Negative Marks for every wrong answer,1/3 Marks
,,,English,50,200,,,
,,,Section - B(Genl Knowledge),,,,,
,,,Physics,20,80,,,
,,,Chemistry,15,60,,,
,,,Biology,15,60,,,
,,,History,15,60,,,
,,,Geography,15,60,,,
,,,General Awareness,20,80,,,
Officer Entry,"CDS - Short Service Commission
","Graduation in Arts, Commerce, Science",PAPER 1(MCQ),100,100,120 Mins,For every right answer,1 Marks
,,,English,100,100,,Negative Marks for every wrong answer,1/3 Marks
,,,PAPER 2(MCQ),100,100,120 Mins,For every right answer,1 Marks
,,,Physics,15,15,,Negative Marks for every wrong answer,1/3 Marks
,,,Chemistry,15,15,,,
,,,Biology,15,15,,,
,,,History,15,15,,,
,,,Geography,10,10,,,
,,,Polity,10,10,,,
,,,Economics,10,10,,,
,,,General Awareness,10,10,,,
Officer Entry,"CDS - Permanent Commission
","Graduation in Arts, Commerce, Science",PAPER 1(MCQ),100,100,120 Mins,For every right answer,1 Marks
,,,English,100,100,,Negative Marks for every wrong answer,1/3 Marks
,,,PAPER 2(MCQ),100,100,120 Mins,For every right answer,1 Marks
,,,Physics,15,15,,Negative Marks for every wrong answer,1/3 Marks
,,,Chemistry,15,15,,,
,,,Biology,15,15,,,
,,,History,15,15,,,
,,,Geography,10,10,,,
,,,Polity,10,10,,,
,,,Economics,10,10,,,
,,,General Awareness,10,10,,,
,,,PAPER 3(MCQ),100,100,120 Mins,For every right answer,1 Marks
,,,Maths,100,100,,Negative Marks for every wrong answer,1/3 Marks
Officer Entry,"AFCAT
","Graduation in Arts, Commerce, Science",PAPER 1(MCQ),100,300,120 Mins,For every right answer,3 Marks
,,,Section - A(Gen English),,,,Negative Marks for every wrong answer,1 Marks
,,,English,20,60,,,
,,,Section - B(Gen Knowledge),,,,,
,,,Physics,5,15,,,
,,,Chemistry,5,15,,,
,,,Biology,5,15,,,
,,,History,5,15,,,
,,,Geography,5,15,,,
,,,Polity,5,15,,,
,,,Economics,5,15,,,
,,,General Awareness,5,15,,,
,,,Section - C(Maths),,,,,
,,,Maths,20,60,,,
,,,Section - D(Reasoning),,,,,
,,,Reasoning,20,60,,,
Officer Entry,"Territorial Army
","Graduation in Arts, Commerce, Science",Paper 1 (Subjective)(English),4,50,60 Mins,,
,,,Essay,1,30,(Not Offered),,
,,,Arrangements of Sentences,1,4,,,
,,,Comprehension,1,6,,,
,,,Fill in the Blanks,1,10,,,
,,,PAPER 2(MCQ)(Gen Knowledge),6,50,60 Mins,,
,,,Physics,5,5,,,
,,,Chemistry,5,5,,,
,,,Biology,5,5,,,
,,,History,5,5,,,
,,,Geography,5,5,,,
,,,Polity,5,5,,,
,,,Economics,5,5,,,
,,,Current affairs,10,10,,,
,,,Reasoning Verbal & Non-verbal,5,5,,,
Officer Entry,"CAPF - Assistant Commandants
","Graduation in Arts, Commerce, Science",PAPER 1(MCQ),125,250,120 Mins,Qualifying Marks ,88
,,,Section - A(Gen Knowledge),,,,For every right answer,2 Marks
,,,Physics,10,20,,Negative Marks for every wrong answer,1/3 Marks
,,,Chemistry,10,20,,,
,,,Bio(Environment & bio-diversity),10,20,,,
,,,History,10,20,,,
,,,Geography,10,20,,,
,,,Polity,10,20,,,
,,,Economics,10,20,,,
,,,Current affairs,15,30,,,
,,,Section - B(Maths),,,,,
,,,Maths,10,20,,,
,,,Section - C(Reasoning),,,,,
,,,Reasoning,15,30,,,
,,,General Ability & Intelligence ,15,30,,,
,,,Paper 2 (Subjective),6,200,,"General Studies, Essay and Comprehension (Not Offered)",
"Army Nursing Officer
","Military Nursing Service
",MSc (Nursing) /PB B Sc (Nursing)/B Sc(Nursing),PAPER 1(MCQ),100,100,90 Mins,For every right answer,1 Marks
,,,English,25,25,,Negative Marks for every wrong answer,0
,,,Nursing,50,50,,,
,,,General Intelligence,25,25,,,
Army Soldier ,Soldier Tradesman,8th/10th,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),35,70,,For every right answer,2 Marks
,,,Elimentary Mathematics,15,30,,Negative Marks for every wrong answer,1/2 Marks
Army Soldier ,Soldier GD/ Sol GD  MT Dvr,10th ,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),15,30,,For every right answer,2 Marks
,,,Elimentary Mathematics,15,30,,Negative Marks for every wrong answer,1/2 Marks
,,,General Science,20,40,,,
Army Soldier ,Soldier NA/ Dresser,"12th Science with Physics, Chemistry, Biology(Botany/Zoology/Bio-Science) & English.",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,40
,,,General Knowledge(Gen Awareness + Science + Arts stream),10,20,,For every right answer,2 Marks
,,,Biology,15,30,,Negative Marks for every wrong answer,1/2 Marks
,,,Chemistry,15,30,,,
,,,Mathematics,5,10,,,
,,,Physics,5,10,,,
Army Soldier ,"Soldier Technical (Avn & Amn Examiner) & (Technical Arms - Arty, Army Air Defence)","12th  Science with Physics, Chemistry, Maths and English ",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,40
,,,General Knowledge(Gen Awareness + Science + Arts stream),10,20,,For every right answer,2 Marks
,,,Physics,10,20,,Negative Marks for every wrong answer,1/2 Marks
,,,Chemistry,15,30,,,
,,,Mathematics,15,30,,,
Army Soldier ,Soldier Clerk/Store Keeper Technical,"12th - Arts, Commerce, Science & English. Maths/Accounts/Book Keeping for Arts & Commerce.",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Part I  ,34
,,,General Knowledge(Gen Awareness + Science + Arts stream),20,40,,Qualifying Marks In Part II,40
,,,Mathematics,20,40,,Total aggregate pass marks in�Part I & II,80
,,,Computer Science,10,20,,For every right answer,2 Marks
,,,PAPER 2(MCQ),50,100,60 Mins,Negative Marks for every wrong answer,1/2 Marks
,,,General English,50,100,,,
Army Soldier ,Sepoy Pharma,10+2 / Intermediate exam and qualified in D Pharma/ B Pharma,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,40
,,,General Knowledge(Gen Awareness + Science + Arts stream),25,50,,For every right answer,2 Marks
,,,General English,25,50,,Negative Marks for every wrong answer,1/2 Marks
,,,PAPER 2(MCQ),50,100,60 Mins,Qualifying Marks In Paper 2 ,60
,,,Section I  ,30,60,,For every right answer,2 Marks
,,,Pharmaceutical  Chemistry ,6,12,,Negative Marks for every wrong answer,1/2 Marks
,,,Bio Chemistry ,6,12,,,
,,,Human Anatomy,6,12,,,
,,,Physical Health Education,6,12,,,
,,,Community Pharma,6,12,,,
,,,Section II  ,20,40,,,
,,,Pharmacology & Toxicology,5,10,,,
,,,Pharma-Jurisprudence,5,10,,,
,,,Drugs Store and Inventory Mgt,5,10,,,
,,,Hospital and Clinical Pharmacy,5,10,,,
Army Havildar,"Hav Education - Arts
","Graduation in Arts, Commerce",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),25,50,,For every right answer,2 Marks
,,,General English,25,50,,Negative Marks for every wrong answer,1/2 Marks
,,,PAPER 2(MCQ),50,100,60 Mins,Qualifying Marks In Paper 2,48
,,,History,15,30,,For every right answer,2 Marks
,,,Geography,15,30,,Negative Marks for every wrong answer,1/2 Marks
,,,Economics,10,20,,,
,,,Polity,10,20,,,
Army Havildar,"Hav Education - Science
",Graduation in Science,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),25,50,,For every right answer,2 Marks
,,,General English,25,50,,Negative Marks for every wrong answer,1/2 Marks
,,,PAPER 2(MCQ),50,100,60 Mins,Qualifying Marks In Paper 2,48
,,,Biology,10,20,,For every right answer,2 Marks
,,,Chemistry,10,20,,Negative Marks for every wrong answer,1/2 Marks
,,,Mathematics,10,20,,,
,,,Physics,10,20,,,
,,,Computer Science,10,20,,,
Army Havildar,"Hav Surveyor Auto Carto
",,N,,,,,
"Army JCO
","Catering JCO
",,N,,,,,
"Army JCO
",RT JCO - Pandit,"Graduation  - Arts, Commerce, Science",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),50,100,,Qualifying Marks In Paper 2,48
,,,PAPER 2(MCQ),50,100,60 Mins,For every right answer,2 Marks
,,,Hindu Religion Subject,50,100,,Negative Marks for every wrong answer,1/2 Marks
"Army JCO
",RT JCO - Maulvi,"Graduation  - Arts, Commerce, Science",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),50,100,,Qualifying Marks In Paper 2,48
,,,PAPER 2(MCQ),50,100,60 Mins,For every right answer,2 Marks
,,,Muslim Religion Subject,50,100,,Negative Marks for every wrong answer,1/2 Marks
"Army JCO
",RT JCO - Padri,"Graduation  - Arts, Commerce, Science",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),50,100,,Qualifying Marks In Paper 2,48
,,,PAPER 2(MCQ),50,100,60,For every right answer,2 Marks
,,,Christian Religion Subject,50,100,,Negative Marks for every wrong answer,1/2 Marks
"Army JCO
",RT JCO - Granthi,"Graduation  - Arts, Commerce, Science",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),50,100,,Qualifying Marks In Paper 2,48
,,,PAPER 2(MCQ),50,100,60 Mins,For every right answer,2 Marks
,,,Sikh Religion Subject,50,100,,Negative Marks for every wrong answer,1/2 Marks
"Army JCO
",RT JCO - Monk,"Graduation  - Arts, Commerce, Science",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Paper 1,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),50,100,,Qualifying Marks In Paper 2,48
,,,PAPER 2(MCQ),50,100,60 Mins,For every right answer,2 Marks
,,,Budh Religion Subject,50,100,,Negative Marks for every wrong answer,1/2 Marks
Airforce Airman,Group 'X' Trades (Technical except Education Instructor),10th ,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,32
,,,English,10,20,,For every right answer,2 Marks
,,,Physics,20,40,,Negative Marks for every wrong answer,1/2 Marks
,,,Mathematics,20,40,,,
Airforce Airman,"Group 'Y' Trades (Non-Technical except Med Asst)
","12th  Science with Physics, Chemistry, Maths and English ",PAPER 1(MCQ),50,100,45 Mins,Qualifying Marks ,40
,,,English ,10,20,,For every right answer,2 Marks
,,,Reasoning,20,40,,Negative Marks for every wrong answer,1/2 Marks
,,,General Awareness,20,40,,,
Airforce Airman,Group 'X' & 'Y': Med Asst Trade,"12th Science with Physics, Chemistry, Biology(Botany/Zoology/Bio-Science) & English.",PAPER 1(MCQ),50,100,85 Mins,Qualifying Marks ,40
,,,English,10,20,,For every right answer,2 Marks
,,,Physics,10,20,,Negative Marks for every wrong answer,1/2 Marks
,,,Mathematics,10,20,,,
,,,Reasoning,10,20,,,
,,,General Awareness,10,20,,,
Navy Sailor,"Artificer Apprentices (AA)
",10th ,PAPER 1(MCQ),100,100,60 Mins,Qualifying Marks ,32
,,,English,25,25,60,For every right answer,1 Marks
,,,Mathematics,25,25,,Negative Marks for every wrong answer,Not known
,,,Science,25,25,,,
,,,General Knowledge,25,25,,,
Navy Sailor,"Matric Recruit(Chef / Steward / Sanitary Hygienist)
",,N,,,,,
Navy Sailor,"Senior Secondary Recruit (SSR)
",,N,,,,,
Territorial Army,"Tradesman
",8th/10th,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),35,70,,For every right answer,2 Marks
,,,Elimentary Mathematics,15,30,,Negative Marks for every wrong answer,1/2 Marks
Territorial Army,"Soldier GD
",10th ,PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks ,32
,,,General Knowledge(Gen Awareness + Science + Arts stream),15,30,,For every right answer,2 Marks
,,,Elimentary Mathematics,15,30,,Negative Marks for every wrong answer,1/2 Marks
,,,General Science,20,40,,,
Territorial Army,"Clerk
","12th - Arts, Commerce, Science & English. Maths/Accounts/Book Keeping for Arts & Commerce.",PAPER 1(MCQ),50,100,60 Mins,Qualifying Marks In Part I  ,34
,,,General Knowledge(Gen Awareness + Science + Arts stream),20,40,,Qualifying Marks In Part II,40
,,,Mathematics,20,40,,Total aggregate pass marks in�Part I & II,80
,,,Computer Science,10,20,,For every right answer,2 Marks
,,,PAPER 2(MCQ),50,100,60 Mins,Negative Marks for every wrong answer,1/2 Marks
,,,General English,50,100,,,
"Coast Guard
",Navik (General Duty),10th ,PAPER 1(MCQ),100,100,60 Mins,Qualifying Marks ,32
,,,Physics,25,25,,For every right answer,1 Marks
,,,Chemistry,25,25,,Negative Marks for every wrong answer,
,,,Mathematics,25,25,,,
,,,English,25,25,60,,
,,,General Knowledge,,,,,
,,,Quantitative Aptitude and Reasoning,,,,,
"Coast Guard
",Yantrik Technical (Mechanical),,PAPER 1(MCQ),100,100,60 Mins,,
,,,Mechanical Engineering,,,,,
,,,English,,,,,
,,,General Knowledge,,,,,
,,,Quantitative Aptitude and Reasoning,,,,,
"Coast Guard
",Yantrik Technical (Electrical),,PAPER 1(MCQ),100,100,60 Mins,,
,,,Electrical Engineering,,,,,
,,,English,,,,,
,,,General Knowledge,,,,,
,,,Quantitative Aptitude and Reasoning,,,,,
"Coast Guard
",Yantrik Technical (Electronics) ,,PAPER 1(MCQ),100,100,60 Mins,,
,,,Electronical Engineering,,,,,
,,,English,,,,,
,,,General Knowledge,,,,,
,,,Quantitative Aptitude and Reasoning,,,,,
Assam Rifles,General Duty ( Rifleman),,N,,,,,
Assam Rifles,Group 'B' (Naib Subedar),,N,,,,,
Assam Rifles,Group 'C' (Tradesman),,N,,,,,
CAPF,"Assistant Commandants (BSF, ITBP, CRPF, SSB, CISF)-UPSC
","Graduation in Arts, Commerce, Science",PAPER 1(MCQ),125,250,120 Mins,Qualifying Marks ,88
,,,Section - A(Gen Knowledge),,,,For every right answer,2 Marks
,,,Physics,10,20,,Negative Marks for every wrong answer,1/3 Marks
,,,Chemistry,10,20,,,
,,,Bio(Environment & bio-diversity),10,20,,,
,,,History,10,20,,,
,,,Geography,10,20,,,
,,,Polity,10,20,,,
,,,Economics,10,20,,,
,,,Current affairs,15,30,,,
,,,Section - B(Maths),,,,,
,,,Maths,10,20,,,
,,,Section - C(Reasoning),,,,,
,,,Reasoning,15,30,,,
,,,General Ability & Intelligence ,15,30,,,
,,,Paper 2 (Subjective),6,200,,"General Studies, Essay and Comprehension (Not Offered)",
CAPF,"Sub-Inspector (BSF, ITBP, CRPF, SSB, CISF)-SSC",,PAPER 1(MCQ),100,100,120 Mins,Qualifying Marks ,35
,,,Part A : Analytical Aptitude & Distinguish Pattern,25,25,,For every right answer,1 Marks
,,,Part B : General Knowledge,25,25,,Negative Marks for every wrong answer,0
,,,Part C : Elementary Mathematics,25,25,,,
,,,Part D : Basic English or Hindi,25,25,,,
CAPF,"Constable GD (BSF, ITBP, Assam Rifles, CRPF, SSB, NIA)-Rect Rallies",10th ,PAPER 1(MCQ),100,100,120 Mins,Qualifying Marks ,35
,,,Part A : Analytical Aptitude & Distinguish Pattern,25,25,,For every right answer,1 Marks
,,,Part B : General Knowledge,25,25,,Negative Marks for every wrong answer,0
,,,Part C : Elementary Mathematics,25,25,,,
,,,Part D : Basic English or Hindi,25,25,,,
`;

/**
 * Here's an extremely simple CSV parser that handles quoted fields with commas,
 * new lines, and escaped double quotation marks. There's no splitting or RegEx.
 * It scans the input string 1-2 characters at a time and builds an array.
 *
 * @see https://stackoverflow.com/a/14991797
 * @param str Comma separated values as a string.
 */
function parseCSV(str: string) {
  const arr: string[][] = [];
  let quote = false; // true means we're inside a quoted field

  // iterate over each character, keep track of current row and column (of the returned array)
  let row = 0;
  let col = 0;
  for (let c = 0; c < str.length; c += 1) {
    const cc = str[c];
    const nc = str[c + 1]; // current character, next character
    arr[row] = arr[row] || []; // create a new row if necessary
    arr[row][col] = arr[row][col] || ""; // create a new column (start with empty string) if necessary

    // If the current character is a quotation mark, and we're inside a
    // quoted field, and the next character is also a quotation mark,
    // add a quotation mark to the current column and skip the next character
    if (cc === '"' && quote && nc === '"') {
      arr[row][col] += cc;
      c += 1;
      continue;
    }

    // If it's just one quotation mark, begin/end quoted field
    if (cc === '"') {
      quote = !quote;
      continue;
    }

    // If it's a comma and we're not in a quoted field, move on to the next column
    if (cc === "," && !quote) {
      col += 1;
      continue;
    }

    // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
    // and move on to the next row and move to column 0 of that new row
    if (cc === "\r" && nc === "\n" && !quote) {
      row += 1;
      col = 0;
      c += 1;
      continue;
    }

    // If it's a newline (LF or CR) and we're not in a quoted field,
    // move on to the next row and move to column 0 of that new row
    if (cc === "\n" && !quote) {
      row += 1;
      col = 0;
      continue;
    }
    if (cc === "\r" && !quote) {
      row += 1;
      col = 0;
      continue;
    }

    // Otherwise, append the current character to the current column
    arr[row][col] += cc;
  }
  return arr;
}

const parsed = parseCSV(csv);

/**
 * Returns the categories from the specifications Excel sheet corresponding to
 * the provided entry id.
 *
 * @param intermediateEntry entry id
 */
export const getCategories = (intermediateEntry: string) => {
  let entry = intermediateEntry.toLowerCase().replace(/-/g, " ");
  if (entry === "army") entry = "army soldier";
  if (entry === "airforce") entry = "airforce airman";
  if (entry === "navy") entry = "navy sailor";
  if (entry === "railway protection force") entry = "navy sailor";

  let rows = parsed.filter(
    row =>
      row[0]
        .trim()
        .toLowerCase()
        .replace(" entry", "") === entry,
  );
  if (!rows) return null;

  rows = rows.filter(row => row[1].trim().length > 0);
  if (rows.length === 0) return null;

  return rows.map(row => ({
    category: row[1].trim(),
    education: row[2].trim().length > 0 ? row[2].trim() : null,
  }));
};
